import { customDateFormatter } from "../../../components/tools";

export const defaultAccountDetailsLogic = (object) => {
  const { team, created_at } = object || {};
  const leftBottom = customDateFormatter(created_at);
  const leftTag = team?.name;
  return { leftBottom, leftTag };
};
